// @flow

import { type Theme } from './types';
import defaultTheme from './default-theme';

const theme: Theme = {
  ...defaultTheme,
  layout: {
    ...defaultTheme.layout,
    hideEbanxHeader: true,
    hideMerchantLogo: true,
  },
};

export default theme;
